export const V3_CONTENT_VERSION = 'markdown_v3';

/**
 * A v3 (markdown) note is not rendered by this app: `getShareV3Request` redirects it to the
 * nx viewer, and that only runs on a real request. `[routerLink]` navigates inside Angular —
 * `RouterLinkWithHref.onClick` calls `navigateByUrl` and ignores `preventDefault` — so a v3
 * child has to be a plain `href` instead, which is a full page load. NIM-43647.
 */
export function isMarkdownV3Child(item): boolean {
  return !!item && item.contentVersion === V3_CONTENT_VERSION;
}
